import React from 'react';
import { ArrowRight, Phone } from 'lucide-react';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="bg-white section-padding" data-testid="hero-section" aria-labelledby="hero-heading">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left: Content */}
          <div className="space-y-6" data-testid="hero-content">
            <p className="overline" data-testid="hero-overline">
              ISO 9001:2015 Certified Printing Press
            </p>
            <h1 id="hero-heading" className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-tight font-heading text-[#1a1a1a]" data-testid="hero-heading">
              Professional
              <br />
              <span className="text-[#003151]">Printing Services</span>
            </h1>
            <p className="text-lg text-gray-600 leading-relaxed max-w-xl" data-testid="hero-description">
              Leading printing press specializing in <strong>commercial printing</strong>, <strong>government contracts</strong>, 
              <strong> magazines</strong>, <strong>books</strong>, <strong>notebooks</strong>, and <strong>binding services</strong>. 
              Trusted by government agencies and enterprises for over <strong>11+ years</strong>.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <button
                onClick={scrollToContact}
                className="btn-primary flex items-center justify-center gap-2 rounded-md"
                data-testid="hero-cta-primary"
                aria-label="Request a printing quote"
              >
                Request a Quote
                <ArrowRight size={18} aria-hidden="true" />
              </button>
              <a
                href="tel:+91 7292909090"
                className="btn-outline flex items-center justify-center gap-2 rounded-md"
                data-testid="hero-cta-secondary"
                aria-label="Call us now"
              >
                <Phone size={18} aria-hidden="true" />
                Call Now
              </a>
            </div>
            
            {/* Trust Indicators */}
            <div className="flex flex-wrap items-center gap-6 pt-4 text-sm text-gray-500">
              <span className="flex items-center gap-2">
                <span className="w-2 h-2 bg-green-500 rounded-full" aria-hidden="true"></span>
                Government Approved
              </span>
              <span className="flex items-center gap-2">
                <span className="w-2 h-2 bg-green-500 rounded-full" aria-hidden="true"></span>
                ISO Certified
              </span>
              <span className="flex items-center gap-2">
                <span className="w-2 h-2 bg-green-500 rounded-full" aria-hidden="true"></span>
                500+ Projects
              </span>
            </div>
          </div>

          {/* Right: Image */}
          <div className="relative" data-testid="hero-image-container">
            <figure className="overflow-hidden rounded-lg">
              <img
                src="https://images.pexels.com/photos/1440504/pexels-photo-1440504.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                alt="Industrial offset printing press machine in operation - professional printing services"
                className="w-full h-auto object-cover"
                data-testid="hero-image"
                loading="eager"
                width="940"
                height="650"
              />
            </figure>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
